import { AI_MATRIX } from "../content";
import { AiSectionHead } from "./AiSection";

/** 能力矩阵表：需求 — 能力 — 关口 — 融合深度 — 价值。对应设计稿第 6 节。 */
export default function AiMatrix() {
  return (
    <section aria-labelledby="ai-matrix-h" className="py-14 lg:py-20">
      <AiSectionHead eyebrow={AI_MATRIX.eyebrow} title={AI_MATRIX.title} sub={AI_MATRIX.sub} />
      <div className="overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-[0_1px_2px_rgba(13,31,60,0.06)]">
        <table className="w-full border-collapse min-w-[780px] text-sm">
          <caption className="caption-top text-left px-6 pt-5 pb-0 text-xs text-[#64748b]">
            融合深度标注：
            <span className="inline-block font-mono text-[11px] font-bold px-2 py-[2px] mx-1 rounded-full bg-[#1a56db]/10 text-[#1a56db] border border-[#1a56db]/28">
              流程级
            </span>
            表示安全产品参与业务流程、不通过不放行；
            <span className="inline-block font-mono text-[11px] font-bold px-2 py-[2px] mx-1 rounded-full bg-[#059669]/10 text-[#059669] border border-[#059669]/30">
              数据级
            </span>
            表示与平台共用同一本台账、可跨视图归因。
          </caption>
          <thead>
            <tr>
              {AI_MATRIX.columns.map((col) => (
                <th
                  key={col}
                  scope="col"
                  className="px-5 py-4 text-left align-top bg-[#0b1b3d] text-white text-xs font-bold tracking-wide whitespace-nowrap"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {AI_MATRIX.rows.map((row) => (
              <tr key={row.need} className="even:bg-[#f9fafb] hover:bg-[#1a56db]/[0.045] transition-colors">
                <td className="px-5 py-4 text-left align-top border-b border-gray-200 font-bold text-[#0d1f3c]">{row.need}</td>
                <td className="px-5 py-4 text-left align-top border-b border-gray-200 text-[#475569]">{row.capability}</td>
                <td className="px-5 py-4 text-left align-top border-b border-gray-200 text-[#475569] whitespace-nowrap">{row.gate}</td>
                <td className="px-5 py-4 text-left align-top border-b border-gray-200 whitespace-nowrap">
                  <span
                    className={`inline-block font-mono text-[11px] font-bold px-2 py-[2px] rounded-full whitespace-nowrap ${
                      row.level === "数据级"
                        ? "bg-[#059669]/10 text-[#059669] border border-[#059669]/30"
                        : "bg-[#1a56db]/10 text-[#1a56db] border border-[#1a56db]/28"
                    }`}
                  >
                    {row.level}
                  </span>
                </td>
                <td className="px-5 py-4 text-left align-top border-b border-gray-200 text-[#475569]">{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
